import React, { useState } from 'react';
import VideoCall from './VideoCall';

function App() {
  const [inCall, setInCall] = useState(false);
  const [roomName, setRoomName] = useState('');
  const [userName, setUserName] = useState('');

  const handleStartCall = () => {
    if (roomName.trim() === '') {
      alert('Por favor, informe o nome da sala.');
      return;
    }
    setInCall(true);
  };

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
      <h1>Videochamada com Jitsi (via IFrame API)</h1>

      {!inCall ? (
        <div style={{ maxWidth: 400 }}>
          <label>Nome da Sala:</label>
          <input
            type="text"
            value={roomName}
            onChange={(e) => setRoomName(e.target.value)}
            placeholder="ex: minhaSala123"
            style={{ width: '100%', marginBottom: '1rem' }}
          />

          <label>Seu Nome:</label>
          <input
            type="text"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            placeholder="ex: João"
            style={{ width: '100%', marginBottom: '1rem' }}
          />

          <button onClick={handleStartCall}>Entrar na Chamada</button>
        </div>
      ) : (
        <VideoCall
          roomName={roomName}
          userName={userName}
          onLeave={() => setInCall(false)}
        />
      )}
    </div>
  );
}

export default App;
